export default {
  props: {
    chat: { type: Object, required: true },
    prevChat: { type: Object, default: null },
    operatorName: { type: String, required: true }
  }
}
